import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { domainToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const workflowApp = defineConnector({
  identifier: "workflow",
  name: "Workflow",
  tagLine: "Call another workflow as an API",
  logo,
  protocol: "http",
  tags: ["custom"],
  defaultUrlPattern: (cfg: Record<string, string>) =>
    domainToRegex(cfg.baseUrl),
  auth: (app) =>
    headerAuth([
      {
        name: "X-3B-Connected-App-Auth",
        value: `${app.id}:{secrets.routeAuthToken}`,
      },
      {
        name: "X-3B-Calling-Execution-Proof",
        value: app.callingExecutionProof ?? "",
      },
    ]),
  // The URL and allowed routes are derived from the backing workflow at
  // execution time, so the generic URL-pattern and CA fields would be no-ops.
  customizeStepHandledInline: true,
  steps: [
    {
      title: "Choose a workflow",
      items: [
        {
          kind: "workflow-picker",
          label: "Workflow",
          helperText: "Calls to this connector run the selected workflow.",
        },
        {
          kind: "exposed-routes",
          label: "Links",
          helperText: "Other workflows call these links to run this workflow.",
        },
      ],
    },
    {
      title: "Customize this connector",
      items: [
        {
          kind: "input",
          label: "Name",
          required: true,
          defaultValue: "Workflow",
          target: { kind: "connectedApp", field: "name" },
          helperText: "How this connector is displayed in 3B.",
        },
      ],
    },
  ],
  // This is very bad; don’t copy it. An empty URL skips the test for this workflow-dependent connector.
  connectionTest: { protocol: "http", request: () => ({ url: "" }) },
  publicEnvVars: (cfg: Record<string, string>): Record<string, string> =>
    cfg.baseUrl ? { WORKFLOW_URL: cfg.baseUrl } : {},
});
